import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { PlatformSettingsApi } from '@/services/platform-settings.api';

/**
 * Public, unauthenticated viewer for a platform content page (Privacy
 * Policy, Terms & Conditions, etc.) — this is the page the "Public URL"
 * link shown in the admin's Content Pages editor actually opens.
 */
export function PublicContentPage() {
  const { key = '' } = useParams();
  const { data, isLoading, isError } = useQuery({
    queryKey: ['public-content-page', key],
    queryFn: () => PlatformSettingsApi.getPublicContentPage(key),
    enabled: !!key,
  });

  if (isLoading) {
    return <div className="mx-auto max-w-3xl px-4 py-16 text-center text-slate-400">Loading…</div>;
  }
  if (isError || !data) {
    return <div className="mx-auto max-w-3xl px-4 py-16 text-center text-slate-400">Page not found.</div>;
  }

  return (
    <div className="mx-auto max-w-3xl px-4 py-12">
      <h1 className="mb-6 text-2xl font-semibold text-slate-900">{data.title}</h1>
      <div className="prose prose-slate max-w-none" dangerouslySetInnerHTML={{ __html: data.body }} />
    </div>
  );
}
